import { render, staticRenderFns } from "./MyCafeMenu.vue?vue&type=template&id=ae820c9a"
import script from "./MyCafeMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyCafeMenu.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports